<script setup>
import PostCalendar from '@frontJs/components/calendars/projectManagement/smo/PostCalendar.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import ListIcon from '@iconify-vue/ph/list';
import PlusIcon from '@iconify-vue/ph/plus';
import { Head } from '@inertiajs/vue3';
import AlertBox from '@js/components/alerts/AlertBox.vue';
import ActionButton from '@js/components/buttons/ActionButton.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { useRoute } from '@js/utils/route';

const { tenant } = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    isPlatformConfigured: {
        type: Boolean,
        required: false,
    },
    defaultPublicationTime: {
        type: String,
        required: true,
    },
});

const { route } = useRoute();

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Calendrier - SMO - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle :tenant-name="tenant.name">
        Gestion de projet - SMO - Calendrier
    </PageTitle>

    <AlertBox v-if="!isPlatformConfigured" type="warning" class="mb-4">
        Le service externe Facebook n'est pas configuré pour ce client. Les
        publications ne pourront pas être créées tant que la page Facebook n'est
        pas renseignée dans la fiche client.
    </AlertBox>

    <PostCalendar
        :tenant="tenant"
        :default-publication-time="defaultPublicationTime"
    >
        <template #actions>
            <ActionButton
                size="small"
                type="secondary"
                :left-icon="ListIcon"
                :href="
                    route('front.projectManagement.smo.posts', {
                        tenant: tenant.id,
                    })
                "
            >
                Liste
            </ActionButton>

            <ActionButton
                size="small"
                :left-icon="PlusIcon"
                :href="
                    route('front.projectManagement.smo.post', {
                        tenant: tenant.id,
                    })
                "
            >
                Ajouter
            </ActionButton>
        </template>
    </PostCalendar>
</template>
